import { render, staticRenderFns } from "./PopUpBanners.vue?vue&type=template&id=2a60113c&scoped=true"
import script from "./PopUpBanners.vue?vue&type=script&lang=js"
export * from "./PopUpBanners.vue?vue&type=script&lang=js"
import style0 from "./PopUpBanners.vue?vue&type=style&index=0&id=2a60113c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a60113c",
  null
  
)

export default component.exports